import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { AmbikaVenderApi } from "../config";

const RouteCard = ({
  route,
  productStatusCode,
  onInfoClick,
  staticStatusCodes,
}) => {
  const formatQuantity = (product) => {
    const ordered = product.product_qty || 0;
    const ready = product.food_ready_qty || 0;
    const dispatched = product.dispatch_qty || 0;
    const parts = [];

    if (ordered !== 0) parts.push(ordered);
    if (ready !== 0) parts.push(ready);
    if (dispatched !== 0) parts.push(dispatched);

    return parts.join(" / ");
  };

  const getStatusIcons = (product) => {
    const icons = [];

    // Add U icon if urgent
    if (product.is_urgent === 1) {
      const urgentStatus = staticStatusCodes.find(
        (status) => status.code === "U"
      );
      if (urgentStatus) {
        icons.push(
          renderStatusIcon(urgentStatus.color_code, "U", urgentStatus.name)
        );
      }
    }

    // Add P icon if parcel
    if (product.is_parcel === 1) {
      const parcelStatus = staticStatusCodes.find(
        (status) => status.code === "P"
      );
      if (parcelStatus) {
        icons.push(
          renderStatusIcon(parcelStatus.color_code, "P", parcelStatus.name)
        );
      }
    }

    // Add status icon
    if (product.status) {
      if (typeof product.status === "string") {
        const staticStatus = staticStatusCodes.find(
          (status) => status.code === product.status
        );
        if (staticStatus) {
          icons.push(
            renderStatusIcon(
              staticStatus.color_code,
              staticStatus.code,
              staticStatus.name
            )
          );
        }
      } else if (typeof product.status === "number") {
        const productStatus = productStatusCode?.find(
          (status) => status.id === product.status
        );
        if (productStatus) {
          icons.push(
            renderStatusIcon(
              productStatus.color_code,
              productStatus.code || "",
              productStatus.name
            )
          );
        }
      }
    }

    return icons;
  };

  const renderStatusIcon = (color, code, tooltip) => {
    return (
      <div
        key={`${code}-${Math.random()}`}
        className="status-icon"
        style={{
          backgroundColor: color,
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "10px",
          marginRight: "5px",
          cursor: "pointer",
        }}
        title={tooltip}
      >
        {code}
      </div>
    );
  };

  return (
    <div className="col-md-6">
      <div className="card no-border h-100">
        <div className="card-body d-flex flex-column">
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <h6 className="fw-bold mb-0 p-3">
              {route.route_name || `Route ${route.route_id}`}
            </h6>
            <span
              className="info-icon p-3"
              style={{ cursor: "pointer" }}
              onClick={onInfoClick}
            >
              <BsFillInfoCircleFill />
            </span>
          </div>

          <ul className="list-unstyled small flex-grow-1">
            {route.product_detail?.map((product, index) => (
              <li
                key={`${product.product_id}-${product.size_name}-${index}`}
                className="d-flex justify-content-between small-list-item px-3"
              >
                <span className="icon-text-wrapper d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    {getStatusIcons(product)}
                  </div>
                  {product.productName} ({product.size_name})
                </span>
                <span>{formatQuantity(product)}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RouteCard;
